/**
 * The `/accounts` route, in one place: `App.tsx` routes it and other modules
 * link to it (M3 Cashflow's "Go to Accounts"), so no copy can drift.
 */
export const ACCOUNTS_PATH = '/accounts'
